import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const onecoConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Oneco Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Oneco, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_oneco',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Oneco',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Oneco Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide the expert tree care that 
     homeowners and businesses in <strong>Oneco</strong> can count on. This busy 
     community between Bradenton and Sarasota has no shortage of mature trees growing 
     close to homes, fences, and power lines and Florida's storm season turns those 
     trees into real hazards fast. Our team takes on the difficult jobs with the right 
     equipment and a commitment to doing it right.`,

    `We specialize in <strong>dangerous tree removal and targeted trimming</strong> 
     large overhanging limbs near structures, storm split trunks, trees leaning from 
     soil saturation after heavy rains, and thick canopy growth that increases your 
     property's vulnerability to wind damage. We handle every phase of the job from 
     assessment to final cleanup.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Oneco</strong> and the surrounding <strong>Central Manatee 
     County</strong> area protecting your property and keeping your trees healthy 
     all year long.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Oneco, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Oneco = () => <LocationPage config={onecoConfig} />;
export default Services_Oneco;
